var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ForgotPwd"},[_c('app-header',{attrs:{"title":_vm.$t('forgotPwd.forgot_pwd')},on:{"on-click":_vm.goBack}}),_c(_vm.currentComponent,{tag:"component",attrs:{"queryObj":_vm.$route.query}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }